var React = require('react');

function Number2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 31.665V35.13H28.88V30.72H15.29L23.3 22.8C27.485 18.705 28.79 15.735 28.79 11.82C28.79 6.78 25.055 3 18.53 3C12.23 3 8.135 7.455 8.135 12.18C8.135 13.305 8.27 14.43 8.675 15.465L13.175 14.655C12.95 14.025 12.815 13.35 12.815 12.63C12.815 9.21 15.245 7.23 18.485 7.23C21.905 7.23 24.11 9.21 24.11 12.45C24.11 15.105 22.985 16.995 20.105 19.875L8 31.665Z"}));
}

Number2.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38"};

module.exports = Number2;

Number2.default = Number2;
